import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
import n from "../_virtual/_plugin-vue_export-helper.mjs";
const s = {}, c = {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function i(l, e) {
  return o(), t("svg", c, e[0] || (e[0] = [
    r("path", {
      d: "M13 1L4.75 9L1 5.36364",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const m = /* @__PURE__ */ n(s, [["render", i]]);
export {
  m as default
};
